import { ReactElement } from "react";
import { useOrderCommentList } from "../../../hooks/api/v2/orderComment/useOrderCommentList";
import { OrderCommentListContent } from "./OrderCommentListContent";

export const OrderCommentList = (props: {
  clamp?: number;
  limit?: number;
  orderId: number;
  connection?: {
    connectionType: "prospect" | "customer";
  };
}): ReactElement => {
  const query = useOrderCommentList({
    limit: 50,
    sortBy: "createdAt",
    sortDir: "asc",
    query: [
      {
        type: "OrderId",
        modifier: "EQUALS",
        value: props.orderId,
      },
    ],
  });
  return <OrderCommentListContent {...props} query={query} />;
};
